export default function Mascost() {
    this.init = () => {
        const sprites = document.querySelectorAll('.sprite-container');
        sprites.forEach((sprite) => {
            this.animationSprite(sprite);
        })
    };

    this.animationSprite = (sprite) => {
        const frameWidth = 112;
        const totalFrames = 4;
        const cycleLength = 4;
        let currentIndex = 0;
        let frameSequence = [];
        let previousLastFrame = null;

        let items = sprite.querySelectorAll('.sprite-item');

        function generateFrameSequence() {
            frameSequence = [];

            for (let i = 0; i < cycleLength; i++) {
                frameSequence.push(i);
            }
        }

        function animateSprite() {
            const currentFrame = frameSequence[currentIndex];
            items.forEach((item, idx) => {
                if (currentFrame === idx){
                    item.classList.remove('hidden')
                }else{
                    item.classList.add('hidden')
                }
            })
            currentIndex = (currentIndex + 1) % cycleLength;
            if (currentIndex === 0) {
                generateFrameSequence();
            }
        }

        generateFrameSequence();

        setInterval(animateSprite, 1000);
    }
}
